import * as React from 'react'

export const IconAvatar = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='12' cy='12' r='10' fill='currentColor' />
    <circle cx='12' cy='10' r='3' fill='#EEE6EF' />
    <path
      d='M5.441 19.549a7.003 7.003 0 0 1 13.118 0A9.961 9.961 0 0 1 12 22a9.961 9.961 0 0 1-6.559-2.451Z'
      fill='#EEE6EF'
    />
  </svg>
)
